<div *ngIf="state" class="status-msg status-{{ state }}">
  <capra-icon *ngIf="shouldShowIcon && state" icon="icon-warning"> </capra-icon>
  <i
    *ngIf="state === NotebookState.Ready || state === NotebookState.Success"
    class="status-icon"
    [ngClass]="{ 'success-success-check-color': state === NotebookState.Success }"
  >
    <span class="ready-icon" *ngIf="state === NotebookState.Ready"></span>
  </i>
  <span class="message">
    <ng-content *ngIf="state === NotebookState.Warning" select="[slot=warning]"></ng-content>
    <ng-content *ngIf="state === NotebookState.Error" select="[slot=error]"></ng-content>
    <ng-content *ngIf="state === NotebookState.Cancelled" select="[slot=cancelled]"></ng-content>
    <ng-content *ngIf="state === NotebookState.Alert" select="[slot=alert]"></ng-content>
    <ng-content *ngIf="state === NotebookState.Running" select="[slot=running]"></ng-content>
    <ng-content *ngIf="state === NotebookState.Loading" select="[slot=loading]"></ng-content>
    <ng-content *ngIf="state === NotebookState.Ready" select="[slot=ready]"></ng-content>
    <ng-content *ngIf="state === NotebookState.Success" select="[slot=success]"></ng-content>
  </span>
  <status-loader
    *ngIf="shouldShowLoader"
    class="status-loader"
    [ngClass]="{ 'status-loading': state === NotebookState.Loading }"
    [pulseOnly]="true"
  >
  </status-loader>
</div>
